import { Component } from '@verndale/core'

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $readmore: this.el.querySelector('.expert-row__link-more'),
      $copy: this.el.querySelector('.expert-row__copy')
    }

    this.clampClass = 'expert-row__copy--hide'
    this.removeGradient = 'expert-row__copy--no-gradient'
    this.checkOverflow()
  }

  addListeners() {
    this.dom.$readmore.addEventListener('click', this.handleClick.bind(this))
    window.addEventListener('resize', this.handleResize.bind(this))
  }

  checkOverflow() {
    if (this.dom.$copy.classList.contains(this.clampClass)) {
      if (this.dom.$copy.scrollHeight > this.dom.$copy.clientHeight + 10) {
        this.dom.$readmore.style = 'display: inline-block'
        this.dom.$copy.classList.remove(this.removeGradient)
      } else {
        this.dom.$readmore.style = 'display: none'
        this.dom.$copy.classList.add(this.removeGradient)
      }
    }
  }

  handleClick() {
    if (!this.dom.$copy.classList.contains(this.clampClass)) {
      this.dom.$readmore.innerText = this.dom.$readmore.dataset.more
      this.dom.$readmore.setAttribute('aria-expanded', false)
    } else {
      this.dom.$readmore.innerText = this.dom.$readmore.dataset.less
      this.dom.$readmore.setAttribute('aria-expanded', true)
    }
    this.dom.$copy.classList.toggle(this.clampClass)
  }

  handleResize() {
    this.checkOverflow()
  }
}

export default Module
